import { useRef } from 'react';

/** Controlled overlays also restore focus when their trigger lives outside Radix. */
export function useOverlayFocusReturn(props: {
  onOpenAutoFocus?: (event: Event) => void;
  onCloseAutoFocus?: (event: Event) => void;
}) {
  const previous = useRef<HTMLElement | null>(null);
  return {
    onOpenAutoFocus: (event: Event) => {
      previous.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      props.onOpenAutoFocus?.(event);
    },
    onCloseAutoFocus: (event: Event) => {
      props.onCloseAutoFocus?.(event);
      if (!event.defaultPrevented && previous.current?.isConnected) {
        event.preventDefault();
        previous.current.focus({ preventScroll: true });
      }
    },
  };
}
